import type { AiCostCallRowPayload } from '@Application/AiCosts/Actions/aiCostCallsFetched';
import AiCostQuantitiesView from '@UI/Store/AiCosts/Views/AiCostQuantitiesView';
import AiCostRelatedView from '@UI/Store/AiCosts/Views/AiCostRelatedView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `costAmount` is `null` when the call has no price ("Non renseigné"), never 0.
 */
class AiCostCallView {
	readonly id: number;
	readonly occurredAt: Date;
	readonly usage: { readonly value: string; readonly label: string };
	readonly facility: { readonly id: number; readonly label: string | null };
	readonly user: { readonly id: number | null; readonly label: string | null };
	readonly model: { readonly id: number | null; readonly label: string };
	readonly costAmount: number | null;
	readonly isEstimatedAfterwards: boolean;
	readonly quantities: AiCostQuantitiesView | null;
	readonly related: AiCostRelatedView | null;

	constructor(payload: AiCostCallRowPayload) {
		this.id = payload.id;
		this.occurredAt = new Date(payload.occurredAt);
		this.usage = payload.usage;
		this.facility = payload.facility;
		this.user = payload.user;
		this.model = payload.model;
		this.costAmount = payload.cost.amount;
		this.isEstimatedAfterwards = payload.cost.isEstimatedAfterwards;
		this.quantities = payload.quantities === null ? null : new AiCostQuantitiesView(payload.quantities);
		this.related = payload.related === null ? null : new AiCostRelatedView(payload.related);

		Object.freeze(this);
	}

	get hasQuantities(): boolean {
		return this.quantities !== null;
	}
}

export default AiCostCallView;
